import { render, staticRenderFns } from "./clienteNovoModal.vue?vue&type=template&id=41b5fe70"
import script from "./clienteNovoModal.vue?vue&type=script&lang=js"
export * from "./clienteNovoModal.vue?vue&type=script&lang=js"
import style0 from "./clienteNovoModal.vue?vue&type=style&index=0&id=41b5fe70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports